var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconRestart = function SvgIconRestart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.732 1.304c.332 0 .601.269.601.601v.876c4.448.172 8 3.773 8 8.19 0 4.526-3.73 8.196-8.333 8.196-4.602 0-8.333-3.67-8.333-8.196 0-.441.363-.798.81-.798.449 0 .812.357.812.798 0 3.645 3.005 6.6 6.711 6.6 3.706 0 6.711-2.955 6.711-6.6 0-3.536-2.826-6.422-6.377-6.593v.854a.602.602 0 0 1-.98.467L7.298 4.036a.602.602 0 0 1 0-.935l2.054-1.663a.602.602 0 0 1 .379-.134ZM8.9 8.29l3.672 2.126c.576.333.572.876 0 1.207L8.9 13.75c-.576.334-1.043.07-1.043-.603V8.894c0-.666.471-.934 1.043-.603Z"
  })));
};

export default SvgIconRestart;